import utils from "./react-utilities";
import Settings from "./settings";
import { Image, Space, Tooltip, Button, Popover, Form, Input } from "antd";
import dayjs from "dayjs";
const CustomFunctions = {
    resetTable(tableFilterName, navigate) {
        localStorage.removeItem(tableFilterName);
        navigate(0);
    },
    courseMgtChangeSheetStatus(record, status, type, table) {
        switch (status) {
            case "approve": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.changeSheetStatus(table.selectedRows, 'approve');
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.changeSheetStatus([record], 'approve');
                }

                break;
            }
            case "publish": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.changeSheetStatus(table.selectedRows, 'publish');
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.changeSheetStatus([record], 'publish');
                }
                break;
            }
            case "release": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.changeSheetStatus(table.selectedRows, 'release');
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.changeSheetStatus([record], 'release');
                }
                break;
            }
            case "unpublish": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.changeSheetStatus(table.selectedRows, 'unpublish');
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.changeSheetStatus([record], 'unpublish');
                }
                break;
            }
        }
    },

    courseMgtSetExamsField(valuesStore, dynamicForm) {
        const settings = valuesStore.getArrayObjectsValue("settings", "prop", "marksAllocationPolicy");
        const val = JSON.parse(settings?.value || "{}");
        const jsx = <Space
            key={'1'}
            style={{
                display: 'flex',
                marginBottom: 8,
            }}
            align="baseline"
        >
            <Form.Item
                name="examLabel"
                label="Label"
                rules={[
                    {
                        required: true,
                    }
                ]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name="examMarks"
                label="Marks"
                rules={[
                    {
                        required: true
                    }
                ]}
            >
                <Input type='number' />
            </Form.Item>
        </Space>;
        //prepare the input fields
        dynamicForm.setFormChildren(jsx);
        //set the values to the prepared input fields. values get assigned throught the name prop of the Form.Item component
        dynamicForm.form.setFieldsValue({
            examLabel: 'Exam',
            examMarks: val?.external
        });
        return jsx;
    },
    courseMgtColumns(btnPermissions, dynamicForm, recallColumn, del, delCallback, setSheetInfo, table, tableFilterName, setHasSetPersistedFilters, navigate, edit, valuesStore, actionExtraButtons) {
        return ([
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => {
                    return <Space size="middle">
                        {btnPermissions?.show_add_sheet_column_button && <Tooltip title="Manage Sheet Column">
                            <Button className='btn-secondaryx border-0x' onClick={e => CustomFunctions.courseMgtManageSheetColumn(setSheetInfo, dynamicForm, recallColumn, del, delCallback, record)}><i className='fas fa-file text-secondary' /></Button>
                        </Tooltip>}
                        {btnPermissions?.show_goto_sheet_button && <Tooltip title="View sheet">
                            <Button className='btn-primaryx border-0x' onClick={e => CustomFunctions.courseMgtGotoSheet(record, table, tableFilterName, setHasSetPersistedFilters, navigate)}><i className='fas fa-eye text-primary' /></Button>
                        </Tooltip>}

                        {btnPermissions?.edit_assigned_course && <Tooltip title="Edit course assignment">
                            <Button className='btn-successx border-0x' onClick={e => CustomFunctions.courseMgtEditRecord(edit, valuesStore, record, 'course_lecturer')}><i className='fas fa-edit text-success' /></Button>
                        </Tooltip>}

                        {btnPermissions?.show_del_course_assignment_button && del.confirm(
                            `${Settings.backend}/delete`,
                            record,
                            'Deleting this item?',
                            { tableName: 'course_lecturer', where: 'id', whereType: 'closed' },
                            <Tooltip placement='bottomLeft' title="Delete course assignment. This action will not work if there are no traces of the assignment">
                                <Button className='btn-dangerx border-0x'>  <i className='fas fa-trash text-danger' /></Button>
                            </Tooltip>
                        )}
                        {btnPermissions?.show_more_actions_on_sheet_button && <Tooltip title="More Actions" placement='bottomRight'>
                            <Popover placement="topLeft" title={'More Actions'} content={actionExtraButtons(record)} trigger="click">
                                <Button className='btn-infox border-0x'><i className='fas fa-external-link-alt text-info' /></Button>
                            </Popover>
                        </Tooltip>}
                    </Space>
                },
            },
            {
                title: '',
                dataIndex: 'status',
                render: (v, r) => {
                    return <>
                        {r.status === 'published' ? <i className='fas fa-check-double text-success' /> : r.status === 'approved' ? <i className='far fa-check-circle text-warning' /> : <i className='fas fa-spinner text-danger' />}
                    </>
                }
            },
            {
                title: 'Course',
                dataIndex: 'course_code',
                ...table.getColumnSearchProps('course_code'),
                render: (_, record) => {
                    return `${record.course_code}(${record.course_name})`
                }
            },
            {
                title: 'AcadYr',
                dataIndex: 'acad_year',
                ...table.getColumnSearchProps('acad_year'),
            },
            {
                title: 'Level',
                filterSearch: true,
                dataIndex: 'mounted_level',
            },
            {
                title: 'Session',
                dataIndex: 'session',
            },
            {
                title: 'Semester',
                filterSearch: true,
                dataIndex: 'semester_id',
            },
            {
                title: 'Program',
                dataIndex: 'program',
                filterSearch: true,
            },
            {
                title: 'Lecturer',
                dataIndex: 'lecturer',
                ...table.getColumnSearchProps('lecturer'),
                render: (_, record) => {
                    return `${record.lecturer}(${record.lecturer_id})`
                }
            },
            // {
            //     title: 'Assigned By',
            //     dataIndex: 'assign_by',
            //     ...table.getColumnSearchProps('assign_by')          
            // },
            {
                title: 'Category',
                dataIndex: 'mounted_for',
                filters: [
                    {
                        text: 'Normal',
                        value: 'normal'
                    },
                    {
                        text: 'Resit',
                        value: 'resit'
                    },
                    {
                        text: 'IC',
                        value: 'ic'
                    }
                ],
            },
            {
                title: 'Submitted',
                dataIndex: 'submitted',
                filters: [
                    {
                        text: 'Yes',
                        value: 1
                    },
                    {
                        text: 'No',
                        value: 0
                    }
                ],
                render: (_, record) => {
                    return record.submitted ? 'Yes' : 'No'
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                filters: [
                    {
                        text: 'Submitting',
                        value: 'submitting'
                    },
                    {
                        text: 'Approved',
                        value: 'approved'
                    },
                    {
                        text: 'Published',
                        value: 'published'
                    }
                ]
            }
        ])
    },

    async courseMgtManageSheetColumn(setSheetInfo, dynamicForm, recallColumn, del, delCallback, record) {
        setSheetInfo(record);
        dynamicForm.setFormChildren(undefined);
        const res = await utils.requestWithReauth('post', `${Settings.backend}/get_sheet_columns`, null, { courseLecturerID: record.custom_id });
        const data = res.results?.map(v => {
            return [v.label, v.marks_allotted,
            <Space>
                {v.label !== 'Exam' && <Tooltip title="Edit sheet column">
                    <Button onClick={e => recallColumn(v.label, v.marks_allotted, v)}><i className='fas fa-edit text-success' /></Button>
                </Tooltip>}
                {/*v.label !== 'Exam' && */del.confirm(
                    `${Settings.backend}/delete`,
                    v,
                    'Are you sure to delete this item',
                    { tableName: 'scheme', where: 'id', whereType: 'closed' },
                    <Tooltip title="Delete sheet column" placement='bottom'>
                        <Button><i className='fas fa-trash text-danger' /></Button>
                    </Tooltip>
                    , undefined, undefined, undefined, delCallback)}
            </Space>
            ];
        });

        const details = utils.getTable(
            [
                <label>Label</label>,
                <label>Marks</label>,
                <label>Actions</label>
            ],
            data, 'w-100 table table-sm table-striped', '', '', '', 3);
        dynamicForm.setChildrenBottom(details);
        dynamicForm.setShowModal(true);
        dynamicForm.setModalTitle(`New Sheet Column(s)/${record.course_code}-${record.session}-${record.acad_year}-${record.mounted_for}`);
    },
    courseMgtGotoSheet(record, table, filterName, setHasSetPersistedFilters, navigate) {
        localStorage.setItem(filterName, JSON.stringify(table.tableParams));
        navigate('../mark_entry', { state: { lecturerID: record?.lecturer_id, courseLecturerID: record?.custom_id, consolidatedIDs: record?.consolidatedIDs } });
        setHasSetPersistedFilters(false);
    },
    courseMgtAssignCourse(add, tableName = 'course_lecturer') {
        add.setTblName(tableName);
        add.setShowModal(true);
        add.setSaveCompleted(false);
    },
    courseMgtEditRecord(edit, valuesStore, record, tableName) {
        const storeKey = 'editableRecord';
        valuesStore.setValue(storeKey, record);
        edit.setTblName(tableName);
        edit.setData(record);
        edit.setRecordKey(storeKey);
        edit.setShowModal(true);
        edit.setSaveCompleted(false);
    },
    courseMgtColFilters: [
        {
            filter: 'session',
            sql: "SELECT session,alias FROM sessions",
            key: 'alias',
            value: 'session'
        },
        {
            filter: 'mounted_level',
            sql: "SELECT level FROM level",
            key: 'level',
            value: 'level'
        },
        {
            filter: 'program',
            sql: "SELECT name,alias FROM programs WHERE show_hide =1 ORDER BY name ",
            key: 'alias',
            value: 'name'
        },
        {
            filter: 'semester_id',
            sql: 'SELECT semester,alias FROM semester',
            key: 'alias',
            value: 'semester'
        },
        {
            filter: 'mount_type',
            sql: 'SELECT distinct mount_type FROM course_lecturer',
            key: 'mount_type',
            value: 'mount_type'
        }
    ],
    async courseMgtSetTableDataURL(permList = [], valuesStore, table) {
        //the permissions are arranged from max to min. Max perms have the highest priority       
        for (let i = 0; i < permList.length; i++) {
            const v = permList[i];
            const hasPerm = await utils.hasPermission(v, null, valuesStore);
            if (hasPerm) {
                table.setDataURL(`${Settings.backend}/${v}`);
                break;
            }
        }
    },
    courseMgtShowBtnUsingPermissions(btnPermissions, setBtnPermissions, valuesStore, table) {
        if (Object.keys(btnPermissions) <= 0) {
            const permList = [
                'show_approve_button',
                'show_publish_button',
                'show_unpublish_button',
                'show_release_sheet_button',
                'show_assign_course_button',
                'show_edit_course_assignment_button',
                'show_del_course_assignment_button',
                'show_add_sheet_column_button',
                'show_goto_sheet_button',
                'show_more_actions_on_sheet_button',
                'show_grade_request_button',
                'show_transfer_button',
                'edit_assigned_course'
            ];
            permList.forEach(async v => {
                const perm = await utils.hasPermission(v, null, valuesStore);
                setBtnPermissions(r => ({ ...r, [v]: perm }));//permission as key and true/false as value
            });
            table.rowSelectionDebug();
        }
    },
    courseMgtSetPersistedFilters(filtersName, columns, table, hasSetPersistedFilters, setHasSetPersistedFilters) {
        const tparams = JSON.parse(localStorage.getItem(filtersName));
        const fi = tparams?.filters;
        if (fi) {
            columns?.forEach(v => {
                if (v.dataIndex in fi) {
                    v['defaultFilteredValue'] = fi[v.dataIndex];
                }
            });
            if (!hasSetPersistedFilters) {
                table.setTableParams(tparams);
                setHasSetPersistedFilters(true);
            }
        }
    },
    async courseMgtSubmitScheme(sheetInfo, recalledColumnInfo, values, dynamicForm, valuesStore) {
        const courseLecturerID = sheetInfo?.custom_id;
        const colID = recalledColumnInfo?.id;
        const data = { courseLecturerID, colID, examEntry: { marks: values.examMarks, label: values.examLabel }, edited: { marks: values.marks, label: values.label }, newEntry: values.myForm };

        const settings = valuesStore.getArrayObjectsValue("settings", "prop", "marksAllocationPolicy");
        const val = JSON.parse(settings?.value || "{}");
        const closedScheme = val?.closed;

        const url = closedScheme ? `${Settings.backend}/save_scheme` : `${Settings.backend}/save_opened_scheme`;
        let res = await utils.requestWithReauth('post', url, null, data);
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Column(s) have been created successfully', 'text-success');
            dynamicForm.setShowModal(false);
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },

    async gradeQuery(queryBy = {}) {
        const res = await utils.requestWithReauth('post', `${Settings.backend}/get_grades_for_calc`, null, queryBy);
        return res.results;
    },

    async calc(setRecords, setCalculatedValues, vals) {
        const records = await CustomFunctions.gradeQuery({ values: vals });
        if (!records) {
            return;
        }
        // const records = [
        //     { student_id: '10104040', grade: 'C', grade_points: 2.00, credit_hours: 3, credit_grade_point: 6.00, semester_id: 1, course_id: 'EDC116', course_name: 'PHILOSOPHY OF EDUCATION, SCHOOL CURRICULUM, SOCIAL CHANGE AND NATIONAL DEVELOPMENT', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'C+', grade_points: 2.50, credit_hours: 3, credit_grade_point: 7.50, semester_id: 1, course_id: 'GPD111', course_name: 'COMMUNICATION SKILLS I', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'C+', grade_points: 2.50, credit_hours: 3, credit_grade_point: 7.50, semester_id: 1, course_id: 'ITC111', course_name: 'INTRODUCTION TO PROGRAMMING', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 1, course_id: 'ITC112', course_name: 'LINEAR ALGEGRA AND CALCULUS', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 1, course_id: 'ITC113', course_name: 'PRINCIPLES OF ACCOUNTING', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 1, course_id: 'ITC114', course_name: 'FUNDAMENTALS OF INFORMATION TECHNOLOGY', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },

        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 2, course_id: 'EDC122', course_name: 'EDUCATIONAL TECHNOLOGY', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'C+', grade_points: 2.50, credit_hours: 3, credit_grade_point: 7.50, semester_id: 2, course_id: 'GPD123DG', course_name: 'AFRICAN STUDIES (POPULATION GROWTH & DEVELOPMENT IN AFRICA)', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 2, course_id: 'ITC121', course_name: 'INFORMATION TECHNOLOGY TOOLS IN EDUCATION', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B+', grade_points: 3.50, credit_hours: 3, credit_grade_point: 10.50, semester_id: 2, course_id: 'ITC122', course_name: 'JAVA PROGRAMMING', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'B', grade_points: 3.00, credit_hours: 3, credit_grade_point: 9.00, semester_id: 2, course_id: 'ITC123', course_name: 'COMPUTER ARCHITECTURE', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'A', grade_points: 4.00, credit_hours: 3, credit_grade_point: 12.00, semester_id: 2, course_id: 'ITC124', course_name: 'DIGITAL ELECTRONICS', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        //     { student_id: '10104040', grade: 'A', grade_points: 4.00, credit_hours: 3, credit_grade_point: 12.00, semester_id: 2, course_id: 'ITC125', course_name: 'DISCRETE MATHEMATICS', acad_year: '2022/2023', dob: '0000-00-00', program: 'program', student_name: 'Thompson', start_date: '2023-01-01', end_date: '2027-01-01', sex: 'Male', start_level: 100, end_level: 400 },
        // ];

        // let d = lastSem(records);
        // console.log(records);
        setRecords(records);
        const grouped = utils.groupBy(records, 'student_id');
        const subgroup = [];
        for (let key in grouped) {
            const b = utils.groupBy(grouped[key], 'semester_id');
            subgroup.push({ [key]: b });
        }

        //Each entry in the subgroup is one student with all of his/her details
        const details = subgroup?.map(v => {
            const entries = Object.entries(v)[0];
            const index_no = entries[0];
            const grades = entries[1];
            let details = { CCR: 0, CGV: 0, CGPA: 0 };
            // name format for transcript [lname, fname mname] 
            // name format for certificate [fname mname lname]           
            const std = {
                index_no,
                dobV2: grouped[index_no][0].dob,
                // dob: new Date(utils.formatDate(grouped[index_no][0].dob)).toLocaleDateString(),
                // dob: utils.formatDateV2(utils.formatDate(grouped[index_no][0].dob), '-', '/'),
                dob: dayjs(grouped[index_no][0]?.dob)?.format('DD/MM/YYYY'),
                program: grouped[index_no][0].program,
                top_up: grouped[index_no][0].top_up,
                student_name: `${grouped[index_no][0].lname || ''}, ${grouped[index_no][0].fname || ''} ${grouped[index_no][0].mname || ''}`?.toUpperCase(),
                cert_student_name: `${grouped[index_no][0].fname || ''} ${grouped[index_no][0].mname || ''} ${grouped[index_no][0].lname || ''}`?.toUpperCase(),
                // period: `${grouped[index_no][0].start_date}/${grouped[index_no][0].end_date}`,
                period: `${utils.normalizeDateFormat(grouped[index_no][0].start_date)}-${utils.normalizeDateFormat(grouped[index_no][0].end_date)}`,
                sex: grouped[index_no][0].sex,
                session: grouped[index_no][0].session,
                startLevel: grouped[index_no][0].start_level,
                endLevel: grouped[index_no][0].end_level,
                semesters: {},
                eduLevel: grouped[index_no][0].undergrad_postgrad,
                startAcadYr: grouped[index_no][0].start_acadyr,
                endAcadYr: grouped[index_no][0].end_acadyr,
                certProgram: grouped[index_no][0].cert_name,
                certProgramCategory: grouped[index_no][0].cert_category
            };
            for (let semester in grades) {
                const semesterDetails = grades[semester];
                let semesterValues = { SCR: 0, SGP: 0, SGPA: 0, hasIC: 0, courses: [], acadYr: '' };
                semesterDetails?.forEach(sd => {
                    semesterValues.hasIC = sd.grade === 'IC' ? 1 : 0;
                    semesterValues.SCR += parseFloat(sd.credit_hours);
                    semesterValues.SGP += parseFloat(sd.credit_grade_point);
                    semesterValues.SGPA = parseFloat(parseFloat(semesterValues.SGP / semesterValues.SCR).toFixed(2));
                    semesterValues.acadYr = sd.acad_year;
                    semesterValues.courses.push({ course_id: sd.course_id, course_name: sd.course_name, credit: sd.credit_hours, grade: sd.grade, grade_point: sd.credit_grade_point, has_resat: sd.has_resat });
                });
                details.CCR += semesterValues.SCR;
                details.CGV += semesterValues.SGP;
                details.CGPA = parseFloat(parseFloat(details.CGV / details.CCR).toFixed(2));
                std['semesters'][semester] = { ...semesterValues, ...details };
            }
            return std;
        });
        setCalculatedValues(details);
    },
    // hasDuplicateCourse(courses, key) {
    //     let tracker = {};
    //     for (const item of courses || []) {
    //         const course = courses[item];
    //         const code = course?.course_id;
    //         if(tracker[code] && tracker[code][credit]){

    //         }

    //     }
    //     return false;
    // },
    //NORMAL GRADE CHANGE REQUEST STATUS CHANGER
    async setGradeStatus(details, type, renderer) {
        let url = '';
        switch (type) {
            case "approve": {
                url = `${Settings.backend}/save_approve_grade_change`;
                break;
            }
            case "decline": {
                url = `${Settings.backend}/save_decline_grade_change`;
                break;
            }
        }
        let res = await utils.requestWithReauth('post', url, null, { data: details });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
            renderer(r => !r);
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },
    //GENERAL COURSES GRADE CHANGE REQUEST STATUS CHANGER
    async setGradeStatusGeneral(details, type, renderer) {
        let url = '';
        switch (type) {
            case "approve": {
                url = `${Settings.backend}/save_approve_grade_change_general`;
                break;
            }
            case "decline": {
                url = `${Settings.backend}/save_decline_grade_change_general`;
                break;
            }
        }
        let res = await utils.requestWithReauth('post', url, null, { data: details });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
            renderer(r => !r);
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },

    //EXTRA GRADE CHANGE REQUEST STATUS CHANGER
    async setGradeStatusExtra(details, type, renderer) {
        let url = '';
        switch (type) {
            case "approve": {
                url = `${Settings.backend}/save_approve_grade_change_extra`;
                break;
            }
            case "decline": {
                url = `${Settings.backend}/save_decline_grade_change_extra`;
                break;
            }
        }
        let res = await utils.requestWithReauth('post', url, null, { data: details });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
            renderer(r => !r);
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },

    //NORMAL GRADE STATUS CHANGER
    async changeSheetStatus(details, type, renderer) {
        let url = '';
        switch (type) {
            case "approve": {
                url = `${Settings.backend}/save_approve_sheet`;
                break;
            }
            case "publish": {
                url = `${Settings.backend}/save_publish_sheet`;
                break;
            }
            case "unpublish": {
                url = `${Settings.backend}/save_unpublish_sheet`;
                break;
            }
            case "release": {
                url = `${Settings.backend}/save_release_sheet`;
                break;
            }
        }
        const data = details.map(v => (v.custom_id));
        let res = await utils.requestWithReauth('post', url, null, { data });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
            // renderer(r=>!r);
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },
    //GENERAL COURSES STATUS CHANGER
    async changeSheetStatusGeneral(details, type, renderer) {
        let url = '';
        switch (type) {
            case "approve": {
                url = `${Settings.backend}/save_approve_sheet_general`;
                break;
            }
            case "publish": {
                url = `${Settings.backend}/save_publish_sheet_general`;
                break;
            }
            case "unpublish": {
                url = `${Settings.backend}/save_unpublish_sheet_general`;
                break;
            }
            case "release": {
                url = `${Settings.backend}/save_release_sheet_general`;
                break;
            }
        }
        const data = details.map(v => (v.custom_id));
        let res = await utils.requestWithReauth('post', url, null, { data });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },

    async changeSheetStatusExtra(details, type, renderer) {
        let url = '';
        switch (type) {
            case "publish": {
                url = `${Settings.backend}/save_publish_sheet_extra`;
                break;
            }
            case "unpublish": {
                url = `${Settings.backend}/save_unpublish_sheet_extra`;
                break;
            }
        }

        let res = await utils.requestWithReauth('post', url, null, { data: details });
        if (res.status === 'Ok') {
            utils.showNotification(undefined, 'Operation successful', 'text-success');
        } else {
            utils.showNotification(undefined, res.msg);
        }
    },


    async viewStudentBasicData(record, drawer, valuesStore) {
        let res = await utils.requestWithReauth('post', `${Settings.backend}/get_student_details`, null, { index_no: record.index_no });
        const details = res.result[0];
        const { Firstname, Lastname, Middlename, ApplicantID, Campus,
            Citizenship, CurrentSemesterName, Department, Gender, IndexNumber,
            Level, PersonalEmail, Program, Status, Stream, StudentType, Telephone, Title } = details;

        const d = valuesStore.getArrayObjectsValue('settings', 'prop', 'student_admission_data_endpoint');
        const emailSuffix = valuesStore.getArrayObjectsValue('settings', 'prop', 'student_mail_suffix');
        // console.log(d,details);
        // return;
        let res1 = await utils.requestWithReauth('post', d.value, null, { applicant_id: ApplicantID });
        const picPath = res1?.res?.filter(v => {
            if (v.lookup_item == 'picture' && v.item.toLowerCase() == 'path') {
                return v;
            }
        });

        drawer.setOpen(true);
        drawer.setPlacement('right');
        drawer.setClosable(false);
        drawer.setTitle(`Details of ${Lastname} ${IndexNumber}`);
        drawer.setWidth(520);

        const data = [
            ['Title', Title],
            ['First Name', Firstname],
            ['Last Name', Lastname],
            ['Middle Name', Middlename],
            ['Gender', Gender],
            ['Citizen Of', Citizenship],
            ['ApplicantID', ApplicantID],
            ['Index Number', IndexNumber],
            ['Program', Program],
            ['Session', Stream],
            ['Level', Level],
            ['Department', Department],
            ['Campus', Campus],
            ['Telephone', Telephone],
            ['Personal Email', PersonalEmail],
            ['Student Email', `${IndexNumber}@${emailSuffix.value}`],
            ['Student Type', StudentType],
            ['Status', Status],
        ];
        const domain = utils.getDomainFromUrl(d.value);
        const table = utils.getTable([], data, 'w-100 table table-striped table-sm', '', '', 'fw-bold');
        const content = <div>
            {
                (picPath && picPath.length) ? <Image
                    width={200}
                    src={`https://${domain}/applicant/${picPath[0]?.value}`}
                />
                    :
                    <Image
                        fallback="data:image/png;base64,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"
                        width={200}
                    />
            }
            {table}
        </div>
        drawer.setContent(content);
        // setStudentViewLoading(false);
    },


    courseMountingConfigColumns() {
        const booleanFilter = [
            {
                text: 'Active',
                value: 1
            },
            {
                text: 'Inactive',
                value: 0
            }
        ];
        const rules = [
            {
                text: 'Exactly',
                value: 'exactly'
            },
            {
                text: 'At Least',
                value: 'atleast'
            },
            {
                text: 'At Most',
                value: 'atmost'
            },
            {
                text: 'Range',
                value: 'range'
            },
            {
                text: 'All',
                value: 'all'
            }
        ];

        return {
            gmcExemptCols: ([
                {
                    title: 'Org. Tpe',
                    dataIndex: 'org_type',
                    columnSearch: true
                },
                {
                    title: 'Semester',
                    dataIndex: 'semester_id',
                },
                {
                    title: 'Session',
                    dataIndex: 'session',
                },
                {
                    title: 'Level',
                    dataIndex: 'mounted_level',
                },
                {
                    title: 'program',
                    dataIndex: 'program_exempted',
                    filterSearch: true
                }
            ]),

            gmcGroupNameCols: ([
                {
                    title: 'Name',
                    dataIndex: 'name',
                    columnSearch: true
                },
                {
                    title: 'Active',
                    dataIndex: 'active',
                    filters: booleanFilter
                }
            ]),

            gmcRuleCols: ([
                {
                    title: 'Group Name',
                    dataIndex: 'group_name',
                    columnSearch: true
                },
                {
                    title: 'Rule',
                    dataIndex: 'rule',
                    filters: rules
                },
                {
                    title: 'Number',
                    dataIndex: 'number',
                    columnSearch: true
                }
            ]),
            mcGroupNameCols: ([
                {
                    title: 'Name',
                    dataIndex: 'name',
                    columnSearch: true
                },
                {
                    title: 'Active',
                    dataIndex: 'active',
                    filters: booleanFilter
                },
                {
                    title: 'Description',
                    dataIndex: 'description',
                    columnSearch: true
                }
            ]),
            mcRulesNameCols: ([
                {
                    title: 'Program',
                    dataIndex: 'which_program',
                    // columnSearch: true
                    filterSearch: true
                },
                {
                    title: 'Semester',
                    dataIndex: 'semester',
                },
                {
                    title: 'Session',
                    dataIndex: 'session',
                },
                {
                    title: 'Rule Name',
                    dataIndex: 'rule_name',
                    columnSearch: true
                },
            ]),
            mcRuleCol: ([
                {
                    title: 'Rule Name',
                    dataIndex: 'rule_name',
                    columnSearch: true
                },
                {
                    title: 'Group Name',
                    dataIndex: 'group_name',
                    columnSearch: true
                },
                {
                    title: 'Rule',
                    dataIndex: 'rule',
                    filters: rules
                },
                {
                    title: 'Number',
                    dataIndex: 'number',
                    columnSearch: true
                },
            ])

        }
    }

    // async viewTxn(record, drawer, valuesStore, Tag, Divider, Space, isMainTxn = true) {
    //     const res = await utils.requestWithReauth('post', `${Settings.backend}/get_student`, null, { indexNumber: record.index_no });
    //     const student = res?.result[0];
    //     drawer.setOpen(true);
    //     drawer.setPlacement('right');
    //     drawer.setClosable(false);
    //     const payItemRealName = valuesStore.getArrayObjectsValue('pay_items', 'alias', record?.pay_item);
    //     const content = <div className='d-flex flex-column'>
    //         <div>
    //             <Divider orientation='center' className='fw-bold text-danger'>Transaction Details</Divider>
    //             <Space direction='vertical fw-bold'>
    //                 <label className='h4'>TxnID: {record?.bank_txn_id || 'N/A'}</label>
    //                 <label className='h4'>Amount: GHC {record?.amt_paid || 'N/A'}</label>

    //                 <label>
    //                     Flow: <Tag
    //                         color={record?.debit_credit == 'dr' ? '#2db7f5' : 'geekblue-inverse'}
    //                     >{record?.debit_credit.toUpperCase() || 'N/A'}</Tag>
    //                 </label>

    //                 <label>Pay Item: {payItemRealName?.item || 'N/A'}</label>

    //                 <label>
    //                     Type: <Tag
    //                         color={record?.is_reversal ? 'grey' : '#00695c'}
    //                     >{record?.is_reversal ? 'Reversal' : 'Not Reversal'}</Tag>
    //                 </label>
    //                 {
    //                     !isMainTxn &&
    //                     <label> Action: {
    //                         record?.declined ?
    //                             <Tag color='volcano' icon={<i className='fas fa-trash' />}> {record?.status?.toUpperCase() || 'N/A'}</Tag>
    //                             : <Tag color='green' icon={<i className='fas fa-check' />}> {record?.status?.toUpperCase() || 'N/A'}</Tag>
    //                     }
    //                     </label>
    //                 }
    //                 <label>Description: {record?.description || 'N/A'}</label>
    //                 <label>Date: {record?.date_inserted || 'N/A'}</label>
    //             </Space>
    //         </div>

    //         <div>
    //             <Divider orientation='center' className='fw-bold text-danger'>Bio Details</Divider>
    //             <Space direction='vertical fw-bold'>
    //                 <label>Student First Name: {record?.fname ?? student?.fname ?? 'N/A'}</label>
    //                 <label>Student Surname: {record?.lname ?? student?.lname ?? 'N/A'}</label>
    //                 <label>Student Middle Name: {record?.mname ?? student?.mname ?? 'N/A'}</label>
    //                 <label>Student Sex: {record?.sex ?? student?.sex ?? 'N/A'}</label>
    //                 <label>Student Level: {record?.current_level ?? student?.current_level ?? 'N/A'}</label>
    //                 <label>Student Session: {record?.session ?? student?.session ?? 'N/A'}</label>
    //                 <label>Student Index No.: {record?.index_no ?? student?.index_no ?? 'N/A'}</label>
    //                 {isMainTxn && <label>Student Status: {record?.status ?? student?.status ?? 'N/A'} </label>}
    //                 <label>Payer Name: {record?.payer_name ?? student?.payer_name ?? 'N/A'}</label>
    //                 <label>Payer Contact: {record?.payer_contact ?? student?.payer_contact ?? 'N/A'}</label>

    //             </Space>
    //         </div>

    //         <div>
    //             <Divider orientation='center' className='fw-bold text-danger'>Bank Details</Divider>
    //             <Space direction='vertical fw-bold'>
    //                 <label>Bank: {record?.bank_code || 'N/A'}</label>
    //                 <label>Account: {record?.bank_acct || 'N/A'}</label>
    //                 <label>Payment Mode: {record?.payment_type || 'N/A'}</label>
    //                 <label>Teller: {record?.teller || 'N/A'}</label>
    //             </Space>
    //         </div>
    //     </div>
    //     drawer.setContent(content);
    // },

    // async changeTxnStatus(details, type, idField) {
    //     let url = '';
    //     switch (type) {
    //         case "review": {
    //             url = `${Settings.backend}/save_review_txn`;
    //             break;
    //         }
    //         case "approve": {
    //             url = `${Settings.backend}/save_approve_txn`;
    //             break;
    //         }
    //         case "decline": {
    //             url = `${Settings.backend}/save_decline_txn`;
    //             break;
    //         }
    //     }
    //     const data = details.map(v => (v[idField]));
    //     let res = await utils.requestWithReauth('post', url, null, { data });
    //     if (res.status === 'Ok') {
    //         message.success('Operation successful');
    //     } else {
    //         message.error(res.msg);
    //     }
    // },


}

export default CustomFunctions;